// extracted by mini-css-extract-plugin
export default {"tableStyle":"Kot_tableStyle__V4MSE","tableRowStyle":"Kot_tableRowStyle__1m3iP","thankYouText":"Kot_thankYouText__F9ALR","tableHead":"Kot_tableHead__UAnPK"};